module.exports = __webpack_public_path__ + "img/partner38.5ce5880e.png";